module.exports = __webpack_public_path__ + "img/man-icon.49c5d0be.svg";